/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{glsl as o}from"../../shaderModules/glsl.js";function d(d,r){if(11!==r.output)return d.vertex.code.add(o`void forwardObjectAndLayerIdColor() {}`),void d.fragment.code.add(o`void outputObjectAndLayerIdColor() {}`);const e=r.instanced;d.varyings.add("objectAndLayerIdColorVarying","vec4");const t=e?"instanceOlidColor":"olidColor";d.attributes.add(t,"vec4"),d.vertex.code.add(o`
    void forwardObjectAndLayerIdColor() {
      objectAndLayerIdColorVarying = ${t} * 0.003921568627451;
    }`),d.fragment.code.add(o`void outputObjectAndLayerIdColor() {
fragColor = objectAndLayerIdColorVarying;
}`)}export{d as ObjectAndLayerIdColor};
